import { UserManager } from 'oidc-client-ts';

export class TokenRenewalService {
  private renewalTimer: NodeJS.Timeout | null = null;

  constructor(private userManager: UserManager) {}

  startProactiveRenewal(): void {
    // Clear any existing timers
    this.stopProactiveRenewal();

    // Schedule periodic verification
    this.renewalTimer = setInterval(
      async () => {
        try {
          const user = await this.userManager.getUser();
          if (!user) return;

          // If the token expires in less than 10 minutes, renew it
          const now = Math.floor(Date.now() / 1000);
          const expiresAt = user.expires_at || 0;
          const timeRemaining = expiresAt - now;

          if (timeRemaining < 600) {
            // 10 minutes in seconds
            await this.userManager.signinSilent();
            console.log('Renewed token');
          }
        } catch (error) {
          console.error('Renewal error:', error);
        }
      },
      5 * 60 * 1000
    ); // Check every 5 minutes
  }
  stopProactiveRenewal(): void {
    if (this.renewalTimer) {
      clearInterval(this.renewalTimer);
      this.renewalTimer = null;
    }
  }
}
